export default function createVariables({ searchQuery }) {
    const variables = {
        query: JSON.stringify(searchQuery),
    };

    return variables;
}
